import { render, staticRenderFns } from "./ModalData.vue?vue&type=template&id=dbd9f816&scoped=true"
import script from "./ModalData.vue?vue&type=script&lang=js"
export * from "./ModalData.vue?vue&type=script&lang=js"
import style0 from "./ModalData.vue?vue&type=style&index=0&id=dbd9f816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd9f816",
  null
  
)

export default component.exports